import { MapSetting } from '@/models/Retailer';

const mapSettings: MapSetting = {
    coordinate: {
        lat: 63,
        lng: 16,
    },
    zoom: 5,
};

export default mapSettings;
